import { render, staticRenderFns } from "./PromoBox.vue?vue&type=template&id=ec9c20d6&scoped=true&"
import script from "./PromoBox.vue?vue&type=script&lang=js&"
export * from "./PromoBox.vue?vue&type=script&lang=js&"
import style0 from "./PromoBox.vue?vue&type=style&index=0&id=ec9c20d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9c20d6",
  null
  
)

export default component.exports